import jwt_decode from "jwt-decode";
import router from "./router";
import store from "./store";
import {
  getToken,
  getRefreshToken,
  checkTokenExpiry,
  clearCookies
} from "./utils/tokenCheck.js";
// import checkToken from "./utils/tokenCheck.js";

const hasPermission = (roles, permissionRoles) => {
  if (roles.includes("admin")) return true; // admin permission passed directly
  if (!permissionRoles) return true;
  return roles.some((role) => permissionRoles.includes(role));
};

const getAssess = (data) => {
  try {
    let obj = JSON.parse(data);
    return obj;
  } catch (err) {
    return {};
  }
};

export const checkAccess = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "assessment") {
        if (cur[1] === "no-access") {
          return false;
        } else {
          return true;
        }
      }
    }
  }
  return false;
};

// page title function
const title = "Assessment";

const getPageTitle = (pageTitle) => {
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
};

// get page title name
const getTitleName = (titleName) => {
  if (titleName != "undefined" && titleName != "null") {
    let val = titleName.replace(/([A-Z])/g, " $&");
    switch (titleName) {
      case "Home":
        return "Topics";
      case "Archivetest":
        return "Inactive Tests";
      case "candidateproctor":
        return "Proctoring Details";
      case "tryCode":
        return "Try Question";
      default:
        if (val.includes("Q P")) {
          val = val.replace("Q P", "QP");
        }
        return val;
    }
  }
};

// const whiteList = ["/login", "/register", "/forgot"];
router.beforeEach((to, from, next) => {
  console.log(to);
  // if (to.query.from != undefined) {
  //   // console.log(to.query.from)
  //   store.commit("userVUEX/setlogoutRedirect", to.query.from);
  // }
  // set page title
  const checktitle = to.meta.title || to.name;
  const titlevalue = getTitleName(String(checktitle));
  document.title = getPageTitle(titlevalue);
  // document.title = getPageTitle(to.meta.title);
  // determine whether the user has logged in
  if (checkAccess()) {
    const hasToken = getToken();
    const expiryTime = checkTokenExpiry();
    if (hasToken && expiryTime) {
      if (
        to.path === "/login" ||
        to.path === "/forgot" ||
        to.path === "/register"
      ) {
        next({ path: "/" });
      } else {
        // determine whether the user has obtained his permission roles through getInfo
        // const hasRoles = store.getters.roles && store.getters.roles.length > 0
        if (store.getters.roles.length === 0) {
          store
            .dispatch("userVUEX/getUserData", "setRole")
            .then((res) => {
              const data = res;
              const permissions = data.permissions;
              const landingPage = data.landingPage;
              // generate accessible routes map based on roles
              store
                .dispatch("GenerateRoutes", { permissions })
                .then((accessRoutes) => {
                  // dynamically add accessible routes
                  router.addRoutes(accessRoutes);

                  router.options.routes = router.options.routes.concat(
                    accessRoutes
                  );

                  // hack method to ensure that addRoutes is complete
                  // set the replace: true, so the navigation will not leave a history record
                  let token = localStorage.getItem("accessToken");
                  store.commit("userVUEX/SET_TOKEN", getToken());
                  store.commit("userVUEX/SET_REFRESH_TOKEN", getRefreshToken());
                  if (token != null && token !== getToken()) {
                    token = null;
                  }
                  if (token != null) {
                    if (to.query.from) {
                      if (to.name == 'ProctoringDashboard' || to.name == 'evaluatetest') next();
                      else {
                        next({
                          path: store.getters.landingPage.landingPage,
                          replace: true,
                        });
                      }
                    } else if(to.name == null && landingPage){
                        next({
                          path: landingPage,
                          replace: true,
                        });
                    } 
                    else
                       {
                      next({ ...to, replace: true });
                    }
                  } else {
                    localStorage.setItem("accessToken", getToken());
                    if (to.name == 'ProctoringDashboard' || to.name == 'evaluatetest') next();
                    else {
                      next({
                        path: store.getters.landingPage.landingPage,
                        replace: true,
                      });
                    }
                  }
                });
            })
            .catch((err) => {
              throw err;
            });
        } else {
          // To check if user has role the component
          if (hasPermission(store.getters.roles, to.meta.routes)) {
            next();
          } else {
            next({ path: "/404", replace: true, query: { noGoBack: true } });
          }
        }
      }
    } else {
      localStorage.clear();
      clearCookies();
      // location.replace("http://localhost:8080/");
      location.replace("https://app.hire3x.com/login?from=assessment");

      /* has no token*/
      // if (whiteList.includes(to.path)) {
      //   next();
      // } else {
      //   // other pages that do not have permission to access are redirected to the login page.
      //   next(`/login?redirect=${to.path}`);
      //   // next({path:"/404"})
      //   // router.push({path:"/Access"})
      // }
    }
  } else {
    localStorage.clear();
    clearCookies();
    // location.replace("http://localhost:8080/");
    location.replace("https://app.hire3x.com/login?from=assessment");
  }
});

router.afterEach(() => { });
